export interface TopicItem {
  id: string;
  type: 'topic';
  title: string;
  summary: string;
  cover: string;
  author: string;
  publishedAt: string;
  category: string;
  tags: string[];
  views: number;
  participants: number;
  lastReplyAt: string;
  replies: string[];
  body: string[];
}

export const topicList: TopicItem[] = [
  {
    id: 'topic-01',
    type: 'topic',
    title: '你心中的年度最佳剧集是哪一部？',
    summary: '不限类型、不限平台，说出那部让你熬夜追完的作品，并聊聊它打动你的瞬间。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20chat%20bubble%20discussion%20board%20with%20film%20icon%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=topic-cover-01&orientation=landscape',
    author: '一起艹话题组',
    publishedAt: '2026-10-12',
    category: '影视',
    tags: ['影视', '剧集', '讨论'],
    views: 48600,
    participants: 3280,
    lastReplyAt: '10 分钟前',
    replies: [
      '今年最惊喜的是一部小成本短剧集，八集讲完一个完整故事，没有一集注水。',
      '我还是选那部慢节奏的老剧，每次重看都能发现新的细节。',
      '推荐大家看一下原创动画，画面和故事都很扎实。',
    ],
    body: [
      '又到一年盘点季。每个人心里大概都有一部「看完之后久久没能缓过来」的剧集。',
      '欢迎在下方分享你的年度最佳，可以简单说说剧情，也可以聊聊某个让你印象深刻的镜头或台词。',
      '规则很简单：友善讨论，不剧透结局，尊重每个人的口味。',
    ],
  },
  {
    id: 'topic-02',
    type: 'topic',
    title: '线下演出回归，你最想去看谁的现场？',
    summary: '从Livehouse到体育场，现场的魅力无法被替代。说说你最近抢到的票或想抢的票。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20concert%20tickets%20and%20a%20hand%20holding%20a%20glow%20stick%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=topic-cover-02&orientation=landscape',
    author: '一起艹话题组',
    publishedAt: '2026-10-11',
    category: '活动',
    tags: ['活动', '演出', '音乐'],
    views: 41200,
    participants: 2760,
    lastReplyAt: '32 分钟前',
    replies: [
      '小场地的现场体验真的太好了，站前排能看清每一个表情。',
      '我抢到了音乐节的早鸟票，已经开始准备露营装备了。',
      '希望多一些民谣专场，安静的现场也很治愈。',
    ],
    body: [
      '过去几年，越来越多的人开始为一场现场演出奔赴另一座城市。',
      '想问问大家：你最想去看谁的现场？又或者，哪一场演出让你至今难忘？',
      '如果愿意，也可以分享抢票的小技巧，帮帮还在等待的乐迷。',
    ],
  },
  {
    id: 'topic-03',
    type: 'topic',
    title: '短剧越来越上头，你最近在追哪一部？',
    summary: '一集三分钟，通勤路上就能看完。短剧为什么这么「真香」，一起来聊聊。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20phone%20screen%20with%20short%20video%20frames%20and%20a%20play%20button%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=topic-cover-03&orientation=landscape',
    author: '一起艹话题组',
    publishedAt: '2026-10-10',
    category: '影视',
    tags: ['影视', '短剧', '讨论'],
    views: 39800,
    participants: 2410,
    lastReplyAt: '1 小时前',
    replies: [
      '短剧的节奏真的很快，一集接一集根本停不下来。',
      '有些短剧反转太刻意了，还是更喜欢生活流的。',
      '推荐一部都市微短剧，三分钟讲完一个完整小故事，很舒服。',
    ],
    body: [
      '碎片时间被短剧填满，已经成了很多人的日常。',
      '它的魅力到底在哪里？是节奏、是反转，还是那种「不用动脑」的轻松感？',
      '分享一下你最近在追的短剧，也可以聊聊你觉得它最吸引人的地方。',
    ],
  },
  {
    id: 'topic-04',
    type: 'topic',
    title: '那些让你二刷三刷的电影，评论区集合',
    summary: '有些电影看完一次不够，每次重看都有新的感受。把你的私藏片单交出来吧。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20film%20strip%20curling%20into%20a%20heart%20shape%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=topic-cover-04&orientation=landscape',
    author: '一起艹话题组',
    publishedAt: '2026-10-09',
    category: '影视',
    tags: ['影视', '电影', '片单'],
    views: 36700,
    participants: 2050,
    lastReplyAt: '2 小时前',
    replies: [
      '我有部电影看了不下五遍，每次看到结尾都会重新理解前面的伏笔。',
      '喜欢那种安静但后劲很大的片子，适合一个人慢慢看。',
      '求推荐适合周末窝在家里看的治愈系电影。',
    ],
    body: [
      '有些电影就像老朋友，隔一段时间就想再见一次。',
      '开个帖子，专门收集大家的「重看片单」，让好片被更多人看到。',
      '欢迎附上一句推荐理由，也许你的一句话就能拯救别人的周末。',
    ],
  },
  {
    id: 'topic-05',
    type: 'topic',
    title: '虚拟偶像能取代真人歌手吗？来辩辩',
    summary: '技术越来越成熟，虚拟角色的舞台表现力也在提升。你更在意表演还是情感？',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20holographic%20virtual%20singer%20silhouette%20with%20digital%20particles%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=topic-cover-05&orientation=landscape',
    author: '一起艹话题组',
    publishedAt: '2026-10-08',
    category: '活动',
    tags: ['活动', '虚拟偶像', '讨论'],
    views: 32100,
    participants: 1780,
    lastReplyAt: '3 小时前',
    replies: [
      '我觉得两者并不冲突，虚拟偶像有它独特的表达方式。',
      '现场演出最重要的还是那种真实的、有温度的连接。',
      '技术如果能承载好的作品，形式其实没那么重要。',
    ],
    body: [
      '虚拟偶像的舞台越来越精致，实时动捕让动作几乎以假乱真。',
      '但音乐与表演最终打动的，是人的情感。这就带来了一个有趣的问题：虚拟偶像能取代真人歌手吗？',
      '欢迎理性讨论，说说你更看重哪一点。',
    ],
  },
  {
    id: 'topic-06',
    type: 'topic',
    title: '分享一个治愈你的小众宝藏内容',
    summary: '不一定是热门，但一定在某个瞬间温暖过你。给同好们一个发现的机会。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20glowing%20lantern%20and%20small%20stars%20in%20a%20cosy%20night%20scene%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=topic-cover-06&orientation=landscape',
    author: '一起艹话题组',
    publishedAt: '2026-10-07',
    category: '八卦',
    tags: ['八卦', '治愈', '分享'],
    views: 28900,
    participants: 1520,
    lastReplyAt: '5 小时前',
    replies: [
      '有一个特别小众的音乐频道，深夜听特别放松。',
      '我喜欢那种没有旁白的风景短片，安安静静看完就很治愈。',
      '一本随笔集，每次心情不好都会翻两页。',
    ],
    body: [
      '热门内容之外，总有一些小众作品悄悄地治愈着我们。',
      '也许是一首歌、一部短片，或者一个默默更新的账号。',
      '把它分享出来吧，说不定会成为别人的宝藏。',
    ],
  },
];